import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class DeadPlant extends PhysicalThing {
	static key = "DeadPlant";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	static deserialize(data: any): DeadPlant {
		const d = new DeadPlant(deserializeXY(data.xy));
		d.visualId = data.visualId;
		return d;
	}
}
